import * as React from 'react';

export interface IntegrationSetupStep {
  title: string;
  body: React.ReactNode;
}

export function IntegrationSetupSteps({
  steps,
  title = 'Setup',
}: {
  steps: IntegrationSetupStep[];
  title?: string;
}) {
  return (
    <section>
      <h2 className="mb-4 text-[16px] font-bold text-[#101828]">{title}</h2>
      <ol className="space-y-5">
        {steps.map((step, i) => (
          <li key={step.title} className="flex gap-3">
            <span
              aria-hidden
              className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-[6px] bg-[#D3F8DF] text-[12px] font-bold text-[#067647]"
            >
              {i + 1}
            </span>
            <div className="min-w-0">
              <p className="text-[14px] font-semibold leading-snug text-[#101828]">
                {step.title}
              </p>
              <div className="mt-0.5 text-[13.5px] leading-relaxed text-[#6A7282]">
                {step.body}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export function SetupCode({ children }: { children: React.ReactNode }) {
  return (
    <code className="rounded-[4px] bg-[#F2F4F7] px-1.5 py-0.5 font-mono text-[12.5px] text-[#101828]">
      {children}
    </code>
  );
}

export default IntegrationSetupSteps;
